import { ActionReducerMap } from '@ngrx/store';
import { IOtpCodeAttemptsState } from '../interfaces/otp-code-attempts-state.interface';
import { IOtpNewCodeRequestAttemptsState } from '../interfaces/otp-new-code-request-attempts-state.interface';
import { otpCodeAttemptReducer } from './otp-code-attempts.reducer';
import { otpNewCodeAttemptRequestReducer } from './otp-new-code-request-attempts.reducer';
import { otpExpiredCodeAttemptReducer } from './otp-expired-code-attempts.reducer';
import { IOtpExpiredCodeAttemptsState } from '../interfaces/otp-expired-code-attempts-state.interface';

export interface IAppState {
  otpCodeAttempt: IOtpCodeAttemptsState;
  otpNewCodeAttempt: IOtpNewCodeRequestAttemptsState;
  otpExpiredCodeAttempt: IOtpExpiredCodeAttemptsState;
}

export const appReducers: ActionReducerMap<IAppState> = {
  otpCodeAttempt: otpCodeAttemptReducer,
  otpNewCodeAttempt: otpNewCodeAttemptRequestReducer,
  otpExpiredCodeAttempt: otpExpiredCodeAttemptReducer
};
